import { FC } from 'react';

import { useApplicationContext } from 'shared/context/ApplicationContext';
import { useListingByPinContext } from 'shared/context/ListingByPinContext';

import { SortListingByPinButtonContainer } from '../SortListingButton';

import { HeaderSEOBlock } from './HeaderSEOBlock';

export const HeaderSEOBlockByPinContainer: FC = () => {
  const {
    listingProperties: { totalOffers },
  } = useListingByPinContext();
  const { config } = useApplicationContext();

  /**
   * @todo Удалить RSку
   * @description Данный функционал появился в задаче CD-184633, будет удалён в задаче CD-185006
   */
  const listingByPinSortingEnabled = config.getStrict<boolean>('Commercial.ListingByPinSorting.Enabled');

  return (
    <HeaderSEOBlock
      offersCount={totalOffers}
      sortButton={totalOffers > 1 && listingByPinSortingEnabled ? <SortListingByPinButtonContainer /> : null}
      toMapButton={null}
    />
  );
};
